import React, { type ReactElement } from 'react';
import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives/compiled';

export const TransitionHomeHeader = ({
	title,
	description,
}: {
	title: string | ReactElement;
	description: string | ReactElement;
}) => (
	<Stack space="space.100">
		<Heading as="h1" size="large">
			{title}
		</Heading>
		{description}
	</Stack>
);
